import React from 'react'
import Modal from '@components/ui/Modal'
import { HelpBody, HelpFooter } from './Footer/Help'
import IconHelp from '@assets/icons/help.svg?react'

const FixedHelpButton = () => {
  return (
    <div className="fixed bottom-24 right-4 z-50 sm:bottom-6 sm:right-6">
      <Modal
        title="Help &amp; Answers"
        size="small"
        trigger={(toggleModal) => (
          <button
            className="fixed-help-btn h-16 w-16 p-0 rounded-full shadow-xl hover:shadow-2xl transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-primary-green focus:ring-offset-2 flex items-center justify-center"
            type="button"
            onClick={() => toggleModal()}
            aria-label="Help & Answers"
          >
            <IconHelp className="h-8 w-8 fixed-help-btn__icon" />
          </button>
        )}
        body={() => <HelpBody />}
        footer={(toggleModal) => <HelpFooter toggleModal={toggleModal} />}
      />
    </div>
  )
}

export default FixedHelpButton

